"use client";

import { useTranslations } from "next-intl";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./dialog";
import { Version } from "@/types";

export interface VersionModalProps {
   isOpen: boolean;
   onClose: () => void;
   versions: Version[];
}

export function VersionModal({ isOpen, onClose, versions }: VersionModalProps) {
   const translation = useTranslations("AppVersion");
   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="max-w-xl h-[90vh]">
            <DialogHeader>
               <DialogTitle className="text-lg font-bold">
                  {translation("updateHistory")}
               </DialogTitle>
            </DialogHeader>

            <div className="mt-4 space-y-6 max-h-[80vh] overflow-auto">
               {versions.map((version) => (
                  <div key={version.version} className="space-y-2">
                     <div className="flex items-center gap-2">
                        <h3 className="font-semibold">Version {version.version}</h3>
                        <span className="text-muted-foreground text-sm">
                           {version.date}
                        </span>
                     </div>

                     <ul className="list-none space-y-1">
                        {version?.changes?.map((change, index) => (
                           <li key={index} className="text-sm">
                              {change.text}
                              {change.link && (
                                 <a
                                    href={change.link}
                                    className="text-blue-500 ml-1"
                                    target="_blank"
                                 >
                                    {`=> detail`}
                                 </a>
                              )}
                           </li>
                        ))}
                     </ul>
                  </div>
               ))}
            </div>
         </DialogContent>
      </Dialog>
   );
}
